// extracted by mini-css-extract-plugin
export default {"sectionTitle":"d34XgD","tile":"juKt8V","selected":"bRCoe9","nameWrapper":"Rjmi5J","nameText":"dO6ziw","arrow":"dOqUlR"};